/*
  DIREVULF — bag page checkout buttons for Shiprocket Checkout (Fastrr).

  Shiprocket's script removes every button named "checkout" so it can put its
  own button in its place. On the bag page (/cart) the theme's two buttons
  (summary "Checkout securely" and the sticky bar "Checkout") sit outside the
  cart form, so Shiprocket removes them and adds nothing back. This puts
  DIREVULF-styled buttons back in both places; clicking one opens the
  Shiprocket checkout popup, or falls back to /checkout if Shiprocket has not
  loaded. The buttons carry no name="checkout", so Shiprocket leaves them alone.
*/
(function () {
  if (window.__dvSrCta) return;
  window.__dvSrCta = true;
  var LOCK = '<svg class="dvb-ic" viewBox="0 0 256 256" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z"/></svg>';
  function go(e) {
    e.preventDefault();
    var sr = window.shiprocketCheckoutEvents;
    if (sr && typeof sr.buyCart === 'function') {
      try { sr.buyCart(e); return; } catch (err) {}
    }
    window.location.href = '/checkout';
  }
  function make(cls, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('data-dv-sr-cta', '');
    b.setAttribute('data-dvb-checkout', '');
    b.innerHTML = LOCK + '<span>' + label + '</span>';
    b.addEventListener('click', go);
    return b;
  }
  function ensure() {
    var cta = document.querySelector('[data-dvb-cta]');
    if (cta && !cta.querySelector('[data-dv-sr-cta]')) {
      cta.querySelectorAll('[name="checkout"]').forEach(function (n) { n.remove(); });
      cta.appendChild(make('dvb-btn dvb-btn--primary dvb-btn--xl', 'Checkout securely'));
    }
    var bar = document.querySelector('[data-dvb-bar] .dvb-bar__main');
    if (bar && !bar.querySelector('[data-dv-sr-cta]')) {
      bar.querySelectorAll('[name="checkout"]').forEach(function (n) { n.remove(); });
      bar.appendChild(make('dvb-btn dvb-btn--primary dvb-bar__cta', 'Checkout'));
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(ensure, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure); else ensure();
  window.addEventListener('load', ensure);
  if (window.MutationObserver) new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
